import React from "react";

import { Row, Col } from "reactstrap";

import './style.scss'; 

export default function Sales () {
    return (
        <Row className="sales">
            <Col xs={12} md={4}>
                <p className="display-text">Achieve sales excellence with our innovative solutions</p>
            </Col>
            <Col xs={12} md={4}>
                <div className="box-gradient">
                    <div className="text-title-box-gradient">
                        <span>100</span>
                        <span className="font-weigh-300">+</span>
                    </div>
                    <p className="text-description-box-gradient">Experts ready to work</p>
                </div>
            </Col>
            <Col xs={12} md={4}>
                <div className="box-gradient">
                    <div className="text-title-box-gradient">
                        <span>99</span>
                        <span className="font-weigh-300">%</span>
                    </div>
                    <p className="text-description-box-gradient">Satisfied users around the world</p>
                </div>
            </Col>
        </Row>
    )
}
